'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('selfAccessRequestControllers')

    .controller('ArrivalController', ['$scope', '$modal', '$state', '$stateParams', '$translate', 'topBar', 'selfAccessRequestService', 'selfAccessRequest', 'processStepsByStepName',
        function ($scope, $modal, $state, $stateParams, $translate, topBar, selfAccessRequestService, selfAccessRequest, processStepsByStepName) {

     if (!$state.is('selfAccessRequest.arrival.completed') &&
          selfAccessRequest.IsSelfAccessRequestSubmitted) {
         $state.go('selfAccessRequest.arrival.completed');
     }

     var totalStepsCompletedOrSkipped = 0;

     $scope.selfAccessRequest = selfAccessRequest;
     $scope.processStepStatusList = selfAccessRequest.ProcessStepStatusList;

     $scope.stepsDone = _.countBy(selfAccessRequest.ProcessStepStatusList, function (process) {
         return process.IsSkipped || process.IsCompleted
     }).true;

     $scope.activeProcessStep = _.find(selfAccessRequest.ProcessStepStatusList, {
         IsPendingCompletion: true
     });

     // Topbar - Load translation asynchronously to avoid race condition
     if (!_.isUndefined($scope.activeProcessStep)) {
         $translate('iam.selfAccessRequest.arrival.pageTitle').then(function(translation) {
             topBar.setTitleAndIcon(translation + ' &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                                   '<i class="' + $scope.activeProcessStep.CssIcon + '"></i> ' + $scope.activeProcessStep.StepTitleEN, 'fa-pencil-square-o');
         });
     }

     // Go to Arrival Confirmation Page
     $scope.goToNeedValidation = function () {

         var process = _.find($scope.processStepStatusList, {
             Step: 'NeedValidation'
         });

         if (!(process.IsInProgress ||
            process.IsCompleted ||
            process.IsActive)) {
             return;
         }

         selfAccessRequestService
          .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'NeedValidation')
          .then(function (request) {
              $state.go(request.SelfRequestPageRoute);
          });

     }

     // Skip Step
     $scope.skipStep = function ($event, step) {
       selfAccessRequestService
         .skipProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, step)
         .then(function (selfAccessRequest) {
           $scope.processStepStatusList = selfAccessRequest.ProcessStepStatusList
           $scope.activeProcessStep = _.find(selfAccessRequest.ProcessStepStatusList, function (processStep) {
             return processStep.IsActive || processStep.IsInProgress;
           });
           $translate('iam.selfAccessRequest.arrival.pageTitle').then(function(translation) {
               topBar.setTitleAndIcon(translation + ' | <i class="' +$scope.activeProcessStep.CssIcon + '"></i> ' +$scope.activeProcessStep.StepTitleEN, 'fa-pencil-square-o');
           });

           $scope.stepsDone = $scope.stepsDone + 1;
         });
     }

     // Go to Location
     $scope.goToLocationEquipment = function () {
         $state.go('selfAccessRequest.arrival.locationEquipment');
     }

     // Go to Other Catalog Permissions
     $scope.goToOtherCatalogPermissions = function () {

         var process = _.find($scope.processStepStatusList, {
             Step: 'OtherCatalogPermissions'
         });
         if (process.IsSkipped) {
             return;
         }
         if (!(process.IsInProgress ||
               process.IsCompleted ||
               process.IsActive)) {
             return;
         }

         $state.go('selfAccessRequest.arrival.otherCatalog', {}, { reload: true });
     }

     // Go To PreAuthorized
     $scope.goToPreAuthorized = function () {


         var process = _.find($scope.processStepStatusList, {
             Step: 'PreAuthorized'
         });


         if (process.IsSkipped) {
             return;
         }

         if (!(process.IsCompleted || process.IsInProgress ||
               process.IsActive)) {
             return;
         }



         if (process.IsCompleted || process.IsInProgress) {
             $state.go('selfAccessRequest.adHoc.preAuthorized', {}, { reload: true });

         }
         else {
             selfAccessRequestService.createPreAuthorizedDecisions($stateParams.userAccessRequestId)
                 .then(function (preAuthorizedDecisions) {
                     if (!_.isUndefined(preAuthorizedDecisions.NoDataReason)) {
                         var modalScope = $scope.$new(true);
                         modalScope.NoDataReason = preAuthorizedDecisions.NoDataReason;
                         var noDecisionsModal = $modal({
                             scope: modalScope,
                             template: require('./preAuthorized/NoDecisionsModal.tpl.html'),
                             placement: 'center'
                         });

                         modalScope.hideModal = function () {
                             noDecisionsModal.$promise.then(noDecisionsModal.hide);
                         };

                         modalScope.okModal = function () {
                             modalScope.hideModal();
                         };

                         modalScope.skipPreAuthorizedStep = function (event) {
                             $scope.skipStep(event, 'PreAuthorized');
                             modalScope.hideModal();
                         }
                         return;
                     }

                     $state.go('selfAccessRequest.arrival.preAuthorized', {}, { reload: true });

                 });
         }


     }

     // Go To Same As
     $scope.goToSameAs = function () {

         var processStep = _.find($scope.processStepStatusList, {
             Step: 'SameAs'
         });

         // InProgress/Completed - Go to Decisions
         if (processStep.IsInProgress || processStep.IsCompleted) {
             $state.go('selfAccessRequest.arrival.sameAs');
             return;
         }

         // Skipped - Do nothing
         if (processStep.IsSkipped) {
             return;
         }

         // Open same as modal
         var modalScope = $scope.$new(true);
         var chooserNewSameAsModal = $modal({
             scope: modalScope,
             template: require('../../../shared/components/controllers/selfAccessRequest/SelectSameAsModal.tpl.html'),
             placement: 'center'
         });

         modalScope.hideModal = function () {
             chooserNewSameAsModal.$promise.then(chooserNewSameAsModal.hide);
         }

         modalScope.okModal = function () {
             modalScope.hideModal();
         }

         modalScope.skipStep = function (event) {
             $scope.skipStep(event, 'SameAs');
             modalScope.hideModal();
         }

         // Add the selected employee
         modalScope.newSameAsEmployee = function (selectedEmployee) {
             modalScope.isLoadingSameAsEmployee = true;

             return selfAccessRequestService
                        .selectSameAsEmployee($stateParams.userAccessRequestId,
                                              selectedEmployee.EmployeeID)
                        .then(function (decisionContainer) {
                            modalScope.isLoadingSameAsEmployee = false;

                            if (decisionContainer.NoDataReason) return decisionContainer;

                            modalScope.hideModal();
                            $state.go('selfAccessRequest.arrival.sameAs', {
                                sameAsEmployeeID: selectedEmployee.EmployeeID
                            }, {
                                reload: true
                            });

                            return decisionContainer;
                        });
         }
     }


     // Go To Special Needs
     $scope.goToSpecialNeeds = function () {

         var process = _.find($scope.processStepStatusList, {
             Step: 'SpecialNeeds'
         });
         if (!(process.IsActive || process.IsSkipped)) {
             return;
         }

         $state.go('selfAccessRequest.arrival.otherNeeds', {});
     }

     // Go To Next Action
     $scope.goToNextAction = function () {

         if (_.isUndefined($scope.activeProcessStep)) return;

         if ($scope.activeProcessStep.Step === "PreAuthorized") {
             $scope.goToPreAuthorized();
             return;
         }

         if ($scope.activeProcessStep.Step === "SameAs") {
             $scope.goToSameAs();
             return;
         }

         if ($scope.activeProcessStep.Step === "OtherCatalogPermissions") {
             $scope.goToOtherCatalogPermissions();
             return;
         }

         if ($scope.activeProcessStep.Step === "SpecialNeeds") {
             $scope.goToSpecialNeeds();
             return;
         }

         if ($scope.activeProcessStep.Step === "NeedValidation") {
             $scope.goToNeedValidation();
             return;
         }
     }

     // Reset Ownership
     $scope.resetOwnership = function () {
         selfAccessRequestService.cancelSelfAccessRequestOwnership($stateParams.userAccessRequestId)
             .then(function (response) {
                 window.location = environment.iamUrl;

          });
     }



 }
]);
